import { render, staticRenderFns } from "./singlelist.vue?vue&type=template&id=15189e00&scoped=true&"
import script from "./singlelist.vue?vue&type=script&lang=js&"
export * from "./singlelist.vue?vue&type=script&lang=js&"
import style0 from "./singlelist.vue?vue&type=style&index=0&id=15189e00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15189e00",
  null
  
)

export default component.exports